import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import './ProjectInvitationCard.scss';

function ProjectInvitationCard({
  consultantName, userUrl, starRating, hourlyRate, status, statusString, roles, bio,
}) {
  return (
    <a href={userUrl} target="_blank" className="project-invitation" rel="noreferrer">
      <div className="style-guide project-invitation-card">
        <div className="name-review-status g-row g-row--between">
          <div className="g-row--always">
            <h3 className="fs-hide">
              {consultantName}
            </h3>
            {starRating
            && (
            <div className="rating-avg">
              <div className="g-row--always">
                <StarRatings
                  rating={starRating || 0}
                  starRatedColor="#EDA318"
                  starHoverColor="#EDA318"
                  starDimension="20px"
                  starSpacing="0.5px"
                  numberOfStars={5}
                  name="rating_avg"
                />
                <span className="body-text-2 medium-weight ms-2">
                  {(starRating && starRating.toFixed(1)) || 0}
                </span>
              </div>
            </div>
            )}
          </div>
          <div>
            {hourlyRate
            && (
            <span className="invitation-hourly-rate mr-8">
              <span className="body-text-2 medium-weight">
                {hourlyRate}
              </span>
              <span className="body-text-2 normal-weight">
                /hour
              </span>
            </span>
            )}
            <span className={`invitation-status body-text-3 ${status === 'rejected' && 'rejected'}`}>
              {statusString}
            </span>
          </div>
        </div>

        <div className="body-text-2 medium-weight">
          {roles}
        </div>

        <div className="bio-row mt-3">
          <div className="body-text-2 normal-weight">
            {bio}
          </div>
        </div>
      </div>
    </a>
  );
}

ProjectInvitationCard.propTypes = {
  consultantName: PropTypes.string.isRequired,
  userUrl: PropTypes.string.isRequired,
  starRating: PropTypes.number.isRequired,
  hourlyRate: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  statusString: PropTypes.string.isRequired,
  roles: PropTypes.string.isRequired,
  bio: PropTypes.string.isRequired,
};

export default ProjectInvitationCard;
